import { useAsyncData, useRouteParams } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useSellerInfo() {
  const { uuid: id } = useRouteParams()
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    `seller-info-${id}`,
    () =>
      $httpFetch('/bm/merchant/shop/:uuid', {
        pathParams: { uuid: id },
        ...(!import.meta.client && { timeout: 500 }),
      }),
    {
      default: () => undefined,
    },
  )
}
